const query = gql`
  fragment NativeAdFields on NativeAdPageRecord {
    slug
    mainHeading
    mainImage {
      url(imgixParams: { crop: focalpoint, fit: crop })
      focalPoint {
        x
        y
      }
    }
    legacyMainImageUrl
    checkmarkList {
      text
    }
    showAppRating
    showReviews
    showAppButtons
    content {
      __typename
      ... on ImageBlockRecord {
        image {
          responsiveImage(
            imgixParams: { maxH: 800 }
            sizes: "(max-width: 1600px) 100vw, 1600px"
          ) {
            srcSet
            webpSrcSet
            sizes
            src
            aspectRatio
            alt
            title
            width
            height
          }
        }
        alignment
        roundedCorners
      }
      ... on WidgetRecord {
        component
      }
      ... on TextBlockRecord {
        bodyCopy
        centeredText
      }
      ... on CalloutBlockRecord {
        text
      }
      ... on ReviewRecord {
        __typename
        rating
        reviewText
        reviewer
      }
      ... on RecipeTeaserBlockRecord {
        __typename
        recipeName
        intro
        calories
        time
        image {
          responsiveImage(
            imgixParams: {
              w: 480
              h: 270
              fm: jpg
              fit: crop
              crop: focalpoint
            }
          ) {
            srcSet
            webpSrcSet
            src
            alt
            title
            base64
            width
            height
          }
        }
      }
      ... on ListPageBlockRecord {
        __typename
        listItems {
          id
          heading
          image {
            responsiveImage(imgixParams: { auto: format }) {
              srcSet
              src
              alt
              base64
              width
              height
            }
          }
          body
        }
      }
      ... on TestimonialsBlockRecord {
        __typename
        testimonials {
          id
          image {
            responsiveImage(imgixParams: { auto: format, w: 882, h: 795 }) {
              srcSet
              src
            }
          }
          heading
          quote
          name
          age
        }
      }
    }
    callout
    cta {
      color
      buttonText
      useOfficialButton
      webSignup
      appStoreUrl
      googlePlayUrl
    }
    discount
    couponCode
    references {
      id
      accessDate
      title
      source
    }
  }
  query NativeAdQuery($slug: String!, $locale: SiteLocale) {
    page: nativeAdPage(filter: { slug: { eq: $slug } }, locale: $locale) {
      ...NativeAdFields
    }
    fallback: nativeAdPage(filter: { slug: { eq: $slug } }, locale: en) {
      ...NativeAdFields
    }
  }
`

module.exports = {
  query,
}
